import {forwardRef} from 'react'

import styles from './CopilotImageHiddenComponent.module.css'

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface CopilotHiddenImageComponentProps {}

// eslint-disable-next-line no-empty-pattern
const CopilotHiddenImageComponent = forwardRef<HTMLImageElement, CopilotHiddenImageComponentProps>(({}, ref) => {
  return <img className={styles.hiddenImage} ref={ref} alt="" />
})

CopilotHiddenImageComponent.displayName = 'CopilotHiddenImageComponent'

export default CopilotHiddenImageComponent
